import 'jquery';
import 'Lib/on-error/on-error';
import 'Lib/touch-retina-to-html-tag/touch-retina-to-html-tag';
import 'Lib/es-page-open/es-page-open';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Lib/js-anchor-link/js-anchor-link';
import 'Lib/font-load/font-load';
import 'Vendor/fancybox/jquery.fancybox.min';
import 'Lib/fancybox-custom/fancybox-custom';
import 'Lib/auth/auth';
import { speed } from 'Lib/speed/speed';
import { eksmoBP } from 'Lib/bp/bp';
import { getW } from 'Lib/w/w';
import { showAuth } from 'Lib/show-auth/show-auth';
import 'Lib/on-width-resize/on-width-resize';
import { whiteLabel } from 'Lib/white-label/white-label';
import 'Bem/site/ajax-form/ajax-form';
import 'Bem/site/checkbox/checkbox';
import 'Bem/journal/video/video';
import 'Bem/site/authors-slider/authors-slider';
import 'Bem/site/img-loader/img-loader';
import 'Bem/site/form/form';
import 'Bem/site/auth-form/auth-form';
import 'Bem/site/mail-form/mail-form';
import 'Bem/site/link-drop-down/link-drop-down';
import 'Bem/journal/article-share/article-share';
import 'Bem/site/book/book';
import 'Bem/site/books-slider/books-slider';
import { isNoEmptyString } from 'Lib/is-no-empty-string/is-no-empty-string';

window.whiteLabel = whiteLabel;
svgSpriteLoader('/landing/rodari/svg/sprite.svg?v=202011101353');

const $body = $('body');
const $link = $('.l__vote-link');
const cLinkVotedHide = 'l__vote-link_voted-hide';
const cLinkVotedShow = 'l__vote-link_voted-show';
const cLinkLoad = 'l__vote-link_load';
const cLinkWait = 'l__vote-link_wait';
const sParent = '.l__load-work-form-file';
const sInputFile = '.l__load-work-form-file-input';
const sFileName = '.l__load-work-form-file-style-loaded-file-name';
const sDeleteFile = '.l__load-work-form-file-style-loaded-delete';
const cDrag = 'l__load-work-form-file_drag';
const cFail = 'l__load-work-form-file_fail';
const cLoad = 'l__load-work-form-file_load';

function toggleMobileMenu(isShow = false) {
    $('.l__burger-checkbox').first().prop('checked', isShow);
}

function toggleHeaderStyleFixed() {
    $('.l__header').toggleClass('l__header_fixed', $(document).scrollTop() > 0);
}

// Input file
$body.on('dragover', sParent, function (e) {
    const $parent = $(this);

    e.preventDefault();
    e.stopPropagation();
    $parent.removeClass(cFail);
    $parent.removeClass(cLoad);
    $parent.addClass(cDrag);
});

$body.on('drop dragleave', sParent, function () {
    const $parent = $(this);

    $parent.removeClass(cFail);
    $parent.removeClass(cLoad);
    $parent.removeClass(cDrag);
});

$body.on('click', sDeleteFile, function (e) {
    const $parent = $(this).closest(sParent);

    e.preventDefault();
    e.stopPropagation();
    $parent.removeClass(cFail);
    $parent.removeClass(cLoad);
    $parent.find(sFileName).html('');
});

$body.on('change', sInputFile, function (e) {
    const $parent = $(this).closest(sParent);

    if (e.target.files[0]) {
        $parent.removeClass(cFail);
        $parent.addClass(cLoad);
        $parent.find(sFileName).html(e.target.files[0].name);
    } else {
        $parent.removeClass(cLoad);
        $parent.addClass(cFail);
        $parent.find(sFileName).html('');
    }
});
// END Input file

// Jury
$('.l__jury a').on('click', (e) => {
    e.preventDefault();
});

$('.l__jury-link').on('click', function () {
    const id = $(this).attr('data-id');

    if (isNoEmptyString(id)) {
        $.fancybox.close();

        $.fancybox.open({
            type: 'html',
            src: $(`.l__jury-description[data-id=${id}]`).first().html(),
            touch: false,
            afterLoad(instance, current) {
                $body.trigger('eksmoFancyboxAfterLoad', [instance, current]);
            },
        });
    }
});
// END Jury

// Toggle header style fixed
toggleHeaderStyleFixed();
$(window).on('scroll', toggleHeaderStyleFixed);

// Partners slider
if (getW() > eksmoBP.smMax) {
    $('.l__partners-cont').addClass('owl-carousel').owlCarousel({
        smartSpeed: speed * 2,
        nav: true,
        items: 1,
        dots: false,
        navContainer: '.l__partners-arrows',
        navClass: ['l__partners-arrows-prev arrow arrow_prev arrow_shadow', 'l__partners-arrows-next arrow arrow_next arrow_shadow'],
        navText: ['', ''],
    });
}

// Vote
$link.on('click', function () {
    const $thisLink = $(this);

    function resetLinks() {
        $link.removeClass(cLinkWait);
        $thisLink.removeClass(cLinkLoad);
    }

    if ($thisLink.hasClass(cLinkVotedHide) || $thisLink.hasClass(cLinkVotedShow)) {
        $.fancybox.close();

        $.fancybox.open({
            type: 'html',
            src: 'Вы уже проголосовали!',
            touch: false,
        });
    } else {
        const id = $thisLink.attr('data-id');

        if (isNoEmptyString(id)) {
            $link.addClass(cLinkWait);
            $thisLink.addClass(cLinkLoad);

            $.get(`/ajax/rodari/vote/add/?id=${id}`, (d) => {
                if (d.trim() === 'AUTH') {
                    showAuth();
                    resetLinks();
                } else {
                    const data = $.parseJSON(d);

                    if (typeof data.STATUS !== 'undefined' && typeof data.MESSAGE !== 'undefined') {
                        if (data.STATUS) {
                            $.fancybox.close();

                            $.fancybox.open({
                                type: 'html',
                                src: 'Спасибо за ваш голос!',
                                touch: false,
                            });

                            resetLinks();
                            $link.not($thisLink).addClass(cLinkVotedHide);
                            $thisLink.addClass(cLinkVotedShow);
                            $thisLink.addClass('btn_bg-none btn_border-orange btn_color-orange');
                            $thisLink.removeClass('btn_orange');
                        } else {
                            $.fancybox.close();

                            $.fancybox.open({
                                type: 'html',
                                src: data.MESSAGE,
                                touch: false,
                            });

                            resetLinks();
                        }
                    }
                }
            }).fail(() => {
                $.fancybox.close();

                $.fancybox.open({
                    type: 'html',
                    src: 'Ошибка! Попробуйте позже.',
                    touch: false,
                });

                resetLinks();
            });
        }
    }
});

// Quotes
if (getW() > eksmoBP.smMax) {
    $('.l__quotes-items').addClass('owl-carousel').owlCarousel({
        smartSpeed: speed * 2,
        nav: true,
        items: 1,
        dots: false,
        navContainer: '.l__quotes-arrows',
        navClass: ['l__quotes-arrows-prev arrow arrow_prev arrow_shadow', 'l__quotes-arrows-next arrow arrow_next arrow_shadow'],
        navText: ['', ''],
        margin: 200,
    });
}

// Facts
if (getW() > eksmoBP.smMax) {
    $('.l__facts-items').addClass('owl-carousel').owlCarousel({
        smartSpeed: speed * 2,
        nav: true,
        items: 3,
        dots: false,
        navContainer: '.l__facts-arrows',
        navClass: ['l__facts-arrows-prev arrow arrow_prev arrow_shadow', 'l__facts-arrows-next arrow arrow_next arrow_shadow'],
        navText: ['', ''],
    });
}

// Click on links
$('.l__load-work-link').on('click', () => {
    const url = $('.l').attr('data-form-url');

    toggleMobileMenu(false);

    if (isNoEmptyString(url)) {
        $.get(url, (data) => {
            if (data.trim() === 'AUTH') {
                showAuth();
            } else {
                $.fancybox.open({
                    type: 'html',
                    src: data,
                    touch: false,
                });
            }
        }).fail(() => {
            $.fancybox.open({
                type: 'html',
                src: 'Ошибка! Попробуйте позже.',
                touch: false,
            });
        });
    }
});

$('.l__header-menu-list-item').on('click', () => {
    toggleMobileMenu(false);
});

$body.on('click', '.l__conditions-link', () => {
    $.fancybox.open({
        type: 'html',
        src: $('.l__conditions').first().html(),
        touch: false,
    });
});
// END Click on links